import { render, staticRenderFns } from "./AccountBalanceModal.vue?vue&type=template&id=1837f8d8&scoped=true&lang=pug&"
import script from "./AccountBalanceModal.vue?vue&type=script&lang=js&"
export * from "./AccountBalanceModal.vue?vue&type=script&lang=js&"
import style0 from "./AccountBalanceModal.vue?vue&type=style&index=0&id=1837f8d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1837f8d8",
  null
  
)

export default component.exports